export function getCampStatus(user, settings) {
  if (!user) return { isEvergreen: false, isAAP: false, currentTrailDay: 1, windowOpen: false, isPostCamp: false };
  
  const passType = user.pass_type || 'free';
  const isEvergreen = passType === 'evergreen' || passType === 'evergreen-aap';
  const isAAP = passType === 'allaccess' || passType === 'evergreen-aap';
  
  let currentTrailDay = 1;
  let windowOpen = true;

  // Window length from settings, default 14
  const windowLength = settings?.evergreen_replay_days ? parseInt(settings.evergreen_replay_days, 10) : 14;
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  if (isEvergreen) {
    if (user.trail_start_date) {
      const [y, m, d] = user.trail_start_date.split('-');
      const start = new Date(y, m - 1, d); // Local midnight
      
      const diffTime = today - start;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
      
      currentTrailDay = diffDays < 0 ? 0 : diffDays;

      if (isAAP) {
        windowOpen = true;
      } else {
        // Open while today <= trail_start_date + windowLength
        windowOpen = diffDays <= windowLength;
      }
    } else {
      currentTrailDay = 0; // Pre-onboarding
      windowOpen = true;
    }
  } else {
    // Standard camp logic
    if (settings?.camp_start) {
      const start = new Date(`${settings.camp_start}T00:00:00-04:00`);
      const diffTime = now - start;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
      currentTrailDay = now >= start ? Math.max(diffDays, 1) : 0;
    }

    if (isAAP) {
      windowOpen = true;
    } else {
      const replayExpiryStr = settings?.replay_expiry;
      windowOpen = replayExpiryStr ? now <= new Date(replayExpiryStr) : true;
    }
  }

  return {
    isEvergreen,
    isAAP,
    currentTrailDay,
    isPostCamp: currentTrailDay > 5,
    windowOpen,
    windowLength
  };
}